"use client";

import { useRef, useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

export default function VideoSection() {
  const videoRef = useRef(null);
  const [showControls, setShowControls] = useState(false);
  const [isMuted, setIsMuted] = useState(true); // Start muted to allow autoplay

  useEffect(() => {
    // Auto-play the video when component mounts (muted to ensure it works)
    if (videoRef.current) {
      // Start muted to ensure autoplay works across browsers
      videoRef.current.muted = true;

      // Try to play with muted (most browsers allow this)
      const playPromise = videoRef.current.play();

      if (playPromise !== undefined) {
        playPromise.catch((error) => {
        });
      }
    }

    // Ensure video keeps playing even if visibility changes
    const handleVisibilityChange = () => {
      if (
        document.visibilityState === "visible" &&
        videoRef.current &&
        videoRef.current.paused
      ) {
        videoRef.current
          .play()
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <div
      className="relative w-full h-full overflow-hidden"
      onMouseEnter={() => setShowControls(true)}
      onMouseLeave={() => setShowControls(false)}
    >
      {/* Video container with curved frame */}
      <div className="relative w-full h-full overflow-hidden rounded-bl-[50px] md:rounded-bl-[150px]">
        {/* Video element with object-fit cover to maintain aspect ratio */}
        <div className="w-full h-full flex items-center justify-center">
          <video
            ref={videoRef}
            className="min-w-full min-h-full object-cover"
            loop
            playsInline
            autoPlay
            controls={false}
            muted={isMuted}
          >
            <source src="/videos/gallyo-promo.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* Video overlay */}
        <div className="absolute inset-0 bg-black opacity-10"></div>

        {/* Custom hover sound controls */}
        <div
          className={`absolute bottom-6 right-6 transition-opacity duration-300 ${
            showControls ? "opacity-100" : "opacity-100"
          }`}
        >
          <button
            onClick={toggleMute}
            className="bg-black bg-opacity-50 text-white p-3 rounded-full hover:bg-opacity-70 transition-all"
            aria-label={isMuted ? "Unmute video" : "Mute video"}
          >
            {isMuted ? (
              <VolumeX className="h-6 w-6" />
            ) : (
              <Volume2 className="h-6 w-6" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
